import { Section } from 'components/section'
import { ChapterFooter } from 'components/layout/chapter-footer'

import { Header } from './header'
import { Graphs } from './graphs'
import { Intro } from './intro'
import { Articles } from './articles'
import { Longread } from './longread'
import { Quiz } from './quiz'
import { authors } from './data'
import { Laws } from './laws'
import { Asterisk } from './styled'

export const Home = () => (
  <>
    <Header />

    <Section containerType="text">
      <p>
        Насилие в отношении женщин – серьезная проблема для всех стран
        Центральной Азии. В регионе регулярно происходят резонансные случаи, а
        новости об убийствах и избиениях женщин постоянно появляются в СМИ.
      </p>
      <p>
        Проект Катерины Афанасьевой "Голоса смелых" совместно с Настоящим
        Временем исследует проблему гендерного насилия в странах Центральной
        Азии и рассказывает истории женщин, переживших насилие.
      </p>
    </Section>

    {/*<Section containerType="text">
      <Graphs />
    </Section>*/}
    <Graphs />

    <Intro />
    <Articles />

    <Section containerType="text">
      <p>
        В рамках проекта мы опросили свыше 900 человек из стран Центральной
        Азии*. Мы интересовались, что они знают и думают о насилии, а также
        спрашивали об их личном опыте.
      </p>
      <Asterisk>*по состоянию на апрель 2025 года</Asterisk>
      <p>
        Свыше 90% участвовавших в опросе – городские жители. Из них 93%
        респондентов были женщины, остальные – мужчины. Всем им в большинстве от
        18 до 44 лет. Важно! Опрос не является социологическим исследованием.
      </p>
      <p>
        Угадайте, как отвечали респонденты и как они видят ситуацию с насилием в
        отношении женщин в регионе.
      </p>
    </Section>

    <Quiz />
    <Laws />
    <Longread />

    <ChapterFooter authors={authors} />
  </>
)
